export default __webpack_public_path__ + "static/media/marketing-2.png";